import axios from '@/services/httpClient';
import { useAuthStore } from '../stores/authStore';
import { getAllOrgArray } from './orgServices';

export const getDashboard = async (period, retryAttempt = false) => {
    const authStore = useAuthStore();
    
    // Calculate dates
    const endDate = new Date();
    const startDate = new Date();
    
    if (period === 'week') {
        startDate.setDate(startDate.getDate() - 7);
    } else if (period === 'month') {
        startDate.setMonth(startDate.getMonth() - 1);
    }

    try {
        const response = await axios.get('/drmata_user/statistics', {
            headers: {
                Authorization: `Bearer ${authStore.accessToken}`,
            },
            params: {
                start_date: startDate.toISOString().split('T')[0],
                end_date: endDate.toISOString().split('T')[0]
            }
        });
    
        return response.data.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            await authStore.refreshAccessToken();
            return getDashboard(period, true);
        }
        throw error;
    }
}

export const getDashboardbyDate = async (periodStart, periodEnd, organizationid, retryAttempt = false) => {
    const authStore = useAuthStore();
    const userDetails = await authStore.fetchUserDetails();
    const userRole = userDetails.Role;
    let endpoint = '';
    let organization = [];

    if(userRole === 'admin'){
        endpoint = "nora_superadmin/statistics"
        organization = await getAllOrgArray();
    }else if(userRole === 'clinic_admin'){
        endpoint = "drmata_user/statistics"
    }

    try {
        const response = await axios.get(`/${endpoint}`, {
            headers: {
                Authorization: `Bearer ${authStore.accessToken}`,
            },
            params: {
                start_date: periodStart,
                end_date: periodEnd,
                organization_uuid: organizationid
            }
        });

        if(organization.length>0){
            response.data.data.organization = organization;
        }
    
        return response.data.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            await authStore.refreshAccessToken();
            return getDashboardbyDate(periodStart, periodEnd, organizationid, true);
        }
        throw error;
    }
}

export const getHealthPings = async (retryAttempt = false) => {
    const authStore = useAuthStore();
    
    try {
        const response = await axios.get('/nora_superadmin/health_pings', {
            headers: {
                Authorization: `Bearer ${authStore.accessToken}`,
            }
        });
    
        return response.data.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            await authStore.refreshAccessToken();
            return getHealthPings(true);
        }
        throw error;
    }
}





